import { Component, Input, OnInit, ViewChild, ComponentFactoryResolver } from '@angular/core';
import { IEbComponent } from "../entitybuilder/entitybuilder.component";
import { EntityBuilderItem } from "../../models/entity-builder-item";
import { ComponentService } from "../../services/component-service.service";
import { EbInnerComponentHostDirective } from '../../directives/eb-inner-component-host.directive';

@Component({
    templateUrl: "./array.component.html",
    standalone: false
})
export class ArrayComponent implements IEbComponent, OnInit {
    @Input() title: string;
    @Input() data: any;
    @Input() parent?: string;
    @Input() isArray?: boolean;

    newArray:boolean = false;

    @ViewChild(EbInnerComponentHostDirective, { static: true }) ebInnerComponentHost: EbInnerComponentHostDirective;

    constructor(
        public componentFactoryResolver: ComponentFactoryResolver,
        public componentService: ComponentService,
        public ebComponentItem: EntityBuilderItem
    ) {

    }
    ngOnInit(): void {
        this.buildModel(this.data);
    }

    add() {
        const serviceObj = {
            name: "",
            data: {
                type: "array",
                items: { type: "" }
            },
            parent: this.parent + "." + this.title + ".items",
            newItem: true
        }
        this.componentService.addObject(serviceObj);
    }

    delete() {
        const serviceObj = {
            name: this.title,
            data: this.data,
            parent: this.parent
        }
        this.componentService.deleteObject(serviceObj);
    }

    edit() {
        const serviceObj: any = {
            name: this.title,
            data: this.data,
        }
        if (this.parent) {
            serviceObj.parent = this.parent;
        }
        this.componentService.editObject(serviceObj);
    }

    buildModel(schema) {
        if (!schema.items) {
            this.newArray = true;
        } else {
            this.loadInnerComponent(Object.keys(schema)[1], schema['items']);
        }
    }

    loadInnerComponent(propName: string, prop) {
        //prop.title = propName;
      //  let newComponent = new EbComponentItem(this.getComponent(prop), prop);
        this.ebComponentItem.createComponent(prop, false, prop);
        let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.ebComponentItem.component);
        let viewContainerRef = this.ebInnerComponentHost.viewContainerRef;

		//let componentRef = viewContainerRef.createComponent(componentFactory);
		let componentRef = viewContainerRef.createComponent(this.ebComponentItem.component);
        (<IEbComponent>componentRef.instance).title = propName;
        (<IEbComponent>componentRef.instance).data = this.ebComponentItem.data; 
        (<IEbComponent>componentRef.instance).parent = this.parent + "." + this.title; 
        (<IEbComponent>componentRef.instance).isArray = true; 

    }
}
